<template>
    <div class="home">
        <div class="dashboard-top">
            <!--<div id="myChart" :style="{width: '300px', height: '300px'}"></div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "home",
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        },
        methods :{
            drawLine(){

            }
        },
        mounted () {
            this.drawLine();
            var _this = this
            _this.send({
                server : 'ai',
                url : '/totals',
                data: {},
                success: function (res) {
                   console.log(res)
                }
            })
        },
    }
</script>

<style scoped>
    .dashWrap{flex:1; /*background:#fff;*/width:100%;overflow-y:auto;display:flex;flex-direction: column;}
    .dashboard-top{flex:0 0 180px; /*background:#fff;*/display:flex;margin:10px;}
</style>
